import React from "react";
import { FiSearch } from "react-icons/fi";

export default function ChatSearch({ chatSearch, handleSearch }) {
  return (
    <div className="relative w-full max-w-md">
      <input
        type="text"
        placeholder="Search"
        className="w-full rounded-full bg-zinc-100 dark:bg-slate-800 pl-10 pr-4 py-2 text-sm outline-none border border-transparent focus:border-indigo-500 dark:text-zinc-100 dark:placeholder:text-zinc-400"
        onChange={(e) => handleSearch(e)}
        value={chatSearch}
      />
      <FiSearch className="absolute left-3 top-8 transform -translate-y-1/2 text-zinc-400" />
    </div>
  );
}
